import { useQuery } from '@/react-query/hooks/useQuery/useQuery';
import { discountCategoryQueries } from '@/services/discount-management/discount-category.queries';

export const useGetDiscountCategoryDetail = (categoryId?: string) => {
  const { data, isLoading } = useQuery({
    ...discountCategoryQueries.detail(categoryId),
  });

  return {
    detail: data?.data,
    isLoading,
  };
};
